// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__25Inc","label":"Completed_label__3Hwht"};